import clsx from "clsx";
import React, { HTMLAttributes } from "react";

type PaperProps = { elevation?: boolean } & HTMLAttributes<HTMLDivElement>;

export default function Paper(props: PaperProps) {
    const { children, className, ...rest } = props;
    return (
        <div
            className={clsx(
                "rounded-[8px] p-[16px] border border-[#E2E8F0] shadow-[0px_4px_8px_-4px_rgba(16, 24, 40, 0.03)] bg-white",
                className
            )}
            {...rest}
        >
            {children}
        </div>
    );
}
